<template>
  <div>
    <a class="btn btn-primary" href="#" @click="$router.go(-1)"><i class="fa fa-arrow-left"></i> 回上一頁</a>
    <!--    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>-->
    <!--    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>-->
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <!--        <th>功能</th>-->
        <th>點燈項目</th>
        <th>內容</th>
        <th>支付緣金</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas.OrderDetails" :key="index">
        <!--        <td width="200px">-->
        <!--          <a role="button" class="btn btn-danger" href="#" @click="deleteData(item.id)">刪除</a>-->
        <!--        </td>-->
        <td>
          {{item.productName}}
        </td>
        <td >
          {{item.name}},{{item.sex}},

          <span z-if="item.birthday">
            {{item.birthday}}
          </span>
          <span z-if="item.age">
          {{item.age}}
          </span>
          <br>
          {{item.mtel}},{{item.tel}}<br>
          {{item.email}}<br>
          <span z-if="item.ownerName">
          {{item.ownerName}}<br>
          </span>
          {{item.address1}}
          <span z-if="item.address2">
          {{item.address2}}<br>
          </span>
          {{item.memo}}
        </td>
        <td>
          {{item.price}}
        </td>
      </tr>

      </tbody>
    </table>

  </div>
</template>

<script>
/**

 **/


import Vue from "vue";
import apiFireGodsec from "@/views/fireGods/js/apiFireGodsec";

export default {
  //name: "setting",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{

      },
    };
  },
  methods: {
    loadData() {
      // let data=apiAdmin.api_getContent(this.queryType);
      // debugger // eslint-disable-line
      // console.log(data);
      let that=this;

      apiFireGodsec.api_Admin_ProductOrder_Get(this.id).then((data)=>{
        let dataApi=data.data.data;
        // let dataApi=apiAdmin.init(data.data.data);
        that.datas=dataApi;
      })
    },
    // submit(){
    //   debugger // eslint-disable-line
    //   apiFireGods.api_Admin_EventDefine_Save(this.datas).then((data)=>{
    //     console.log(data);
    //     alert('儲存成功')
    //   })
    // },
    convertToRealUrl(url){
      return Vue.prototype.$apiAdress.replace(/\/$/, "") +url;
    },
    // deleteData(id){
    //   let that=this;
    //   if(confirm("確定刪除?")){
    //     apiFireGods.api_Admin_EventApplicants_Delete(id).then((data)=>{
    //       that.loadData();
    //     })
    //   }
    // },
  },
  mounted() {
    this.id=this.$route.query.id
    this.loadData()
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  /*width: 40px;*/
}
</style>

